.label {
  width: fit-content;
}
